import { variablePlugins } from '@ff-scene-plugins/gift-shared/registry';
import { colorAttributePdpPlugin } from '@gift-variable-plugins/color-attribute-pdp/colorAttributePdpPlugin';
import { engravingPdpPlugin } from '@gift-variable-plugins/engraving-pdp/engravingPdpPlugin';
import { paintablesPdpPlugin } from '@gift-variable-plugins/paintables-pdp/paintablesPdpPlugin';
import { photoPdpPlugin } from '@gift-variable-plugins/photo-pdp/photoPdpPlugin';
import { sizeAttributePdpPlugin } from '@gift-variable-plugins/size-attribute-pdp/src/sizeAttributePdpPlugin';
import { svgPdpPlugin } from '@gift-variable-plugins/svg-pdp/svgPdpPlugin';
import { textPdpPlugin } from '@gift-variable-plugins/text-pdp/textPdpPlugin';

export const registerVariablePlugins = () => {
    variablePlugins.use(textPdpPlugin);
    variablePlugins.use(svgPdpPlugin);
    variablePlugins.use(engravingPdpPlugin);
    variablePlugins.use(paintablesPdpPlugin);
    variablePlugins.use(photoPdpPlugin);
    variablePlugins.use(colorAttributePdpPlugin);
    variablePlugins.use(sizeAttributePdpPlugin);
};